module.exports = __webpack_public_path__ + "img/tr.70ffd6c6.png";